import { render, staticRenderFns } from "./InputSlider.vue?vue&type=template&id=be137bc8&scoped=true&"
import script from "./InputSlider.vue?vue&type=script&lang=ts&"
export * from "./InputSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be137bc8",
  null
  
)

export default component.exports